import { render, staticRenderFns } from "./userMergeAgreement.vue?vue&type=template&id=1d2a7a94&scoped=true"
import script from "./userMergeAgreement.vue?vue&type=script&lang=js"
export * from "./userMergeAgreement.vue?vue&type=script&lang=js"
import style0 from "./userMergeAgreement.vue?vue&type=style&index=0&id=1d2a7a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2a7a94",
  null
  
)

export default component.exports